<template>
  <div :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="px-2 py-4 lg:py-6 xl:pt-8 xl:pb-12 max-w-lg mx-auto">
      <div class="mx-auto mb-4 sm:border border-gray-700 rounded overflow-hidden">
        <div class="signin w-full flex justify-center sm:justify-end">
          <div class="w-full pt-4 md:pt-6 lg:pt-12 pb-6 md:pb-8">
            <div class="dialog__header px-4 md:px-8 lg:px-10 pt-4 pb-4 lg:pb-8">
              <p class="text-NotoSansBold text-center text-base align-top tracking-wide textColorDark mb-3">
                Facebook帳號綁定
              </p>
              <p class="text-NotoSansRegular text-center text-sm align-top mb-2 tracking-wide textColorDark">
                您的Email帳號 {{ account }} 已是註冊會員，現在就完成您的Facebook登入連結綁定，立即同步你的帳戶資料，下次登入就能更輕鬆快速囉! :)
              </p>
            </div>
            <div class="dialog__body">
              <form class="bg-white px-4 md:px-8 lg:px-10 pt-4 pb-4 lg:pb-8" id="form-login" action="" method="POST">
                <div class="mb-6 relative">
                  <input type="email" class="borderColorDarkGray text-sm appearance-none border rounded w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900"
                    id="username" placeholder="Email Address 會員帳號" v-model.trim="account" readonly name="account" v-on:keyup.13="codeCheck" />
                </div>
                <div class="mb-8 relative">
                  <input type="password" class="borderColorDarkGray text-sm appearance-none border rounded w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900 cursor-text"
                    id="password" placeholder="Password 會員密碼" v-model.trim="password" autocomplete="off"  name="password" v-on:keyup.13="codeCheck" />
                </div>
                <button class="text-base button-red text-white py-3 px-4 rounded outline-none focus:outline-none w-full text-NotoSansRegular mb-4 sm:mb-0 cursor-pointer"
                  type="button" ref="btnLogin" :class="{ disabled: isLogining }">
                  送出<font-awesome-icon icon="circle-notch" spin v-if="isLogining" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import { mapGetters } from 'vuex'
// import axios from 'axios'
export default {
  name: 'Login_FB',
  metaInfo () {
    return {
      title: 'Facebook帳號綁定',
      titleTemplate: null
    }
  },
  data () {
    return {
      account: 'abc@gmail.com',
      password: '',

      isLogining: false
    }
  },
  components: {
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      'authorized'
    ])
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .disabled {
    background-color: #872122 !important;
    cursor: not-allowed;
  }

  .input-text {
    background-color: white;
    border: 1px solid #cccccc;
    padding: 8px 4px;
    position: relative;
    width: 100%;
    z-index: 3;
  }

</style>
